import { Navigation } from './navigation';
import { RecomendacaoMenuModel } from 'projects/core/src/lib/core/model/RecomendacaoMenuModel';
import { ContratoProvider } from 'projects/core/src/lib/core/provider/ContratoProvider';
import { ResponseModel } from 'projects/core/src/lib/core/model/ResponseModel';
import { CommandNotificationModel } from 'projects/core/src/lib/core/model/CommandNotificationModel';
import { GatewayNotification } from 'projects/core/src/lib/core/GatewayNotification';
import { UsuarioModel } from 'projects/core/src/lib/core/model/UsuarioModel';
import { TratamentoGatewayService } from 'projects/core/src/lib/core/TratamentoGatewayService';
import { ContratoWrapperModel } from 'projects/core/src/lib/core/model/ContratoWrapperModel';
import { FirebaseWrapper } from 'projects/core/src/lib/core/FirebaseWrapper';
import { TokenProvider } from 'projects/core/src/lib/core/provider/TokenProvider';
import { NotificacoesModel } from 'projects/core/src/lib/core/model/NotificacoesModel';
import { ThrowError } from 'projects/core/src/lib/core/ThrowError';
import { AppStorage } from 'projects/core/src/lib/core/AppStorage';
import { AppSession } from 'projects/core/src/lib/core/AppSession';
import { PushNotifications, ActionPerformed } from '@capacitor/push-notifications';

export class NavigationViewModel {
    context: Navigation
    contratoProvider = new ContratoProvider()
    tokenProvider = new TokenProvider()
    notificacoesModel = new NotificacoesModel()

    constructor() { }

    getContext(): Navigation {
        return this.context
    }

    setContext(context: Navigation) {
        this.context = context
    }

    async getContadorNotificacoes() {
        var notificacoes: Array<any> = await AppStorage.get(AppSession.CHAVE_LISTA_NOTIFICACOES)
        let count = 0;
        for (let i in notificacoes) {
            if (notificacoes[i].tag == RecomendacaoMenuModel.PN_OPERACOES_NO_DIA
                || notificacoes[i].tag == RecomendacaoMenuModel.PN_CURTO_PRAZO
                || notificacoes[i].tag == RecomendacaoMenuModel.PN_LONGO_PRAZO) {
                    count++;
                }
        }
        return count;
    }

    async salvaNotificacaoLocal(notificacao: any) {
        var listaNotificacoes: Array<any> = await AppStorage.get(AppSession.CHAVE_LISTA_NOTIFICACOES)
        if (!listaNotificacoes) listaNotificacoes = []
        listaNotificacoes.push(notificacao)
        await AppStorage.set(AppSession.CHAVE_LISTA_NOTIFICACOES, listaNotificacoes)
    }

    async buscaContratos() {
        let retorno = await this.contratoProvider.listaContratosPorUsuario()
        this.getContext().setListaContratos(retorno)
    }

    async apiBuscaContratos() {
        let retorno = await this.contratoProvider.apiListaContratosPorUsuario()
        try {
            retorno = new TratamentoGatewayService(this.getContext()).builder(retorno)
            if (retorno.status == ResponseModel.STATUS_OK) {
                await AppStorage.set(AppSession.CHAVE_CONTRATO_USUARIO, retorno.data)
            } else {
                await AppStorage.set(AppSession.CHAVE_CONTRATO_USUARIO, new ContratoWrapperModel())
            }
            this.getContext().setListaContratos(retorno.data)
        } catch(e) {
            throw Error(ThrowError.MESSAGE_DEFAULT)
        }
    }

    async userAuthenticate() {
        return await AppSession.userAuthenticate()
    }

    quebrarSessao() {
        AppSession.clearSession()
        this.getContext().openPage("login")
    }

    async configuraTopicsFirebase(notificacoesModel: NotificacoesModel) {
        await new FirebaseWrapper().configuraTopicsFirebase(notificacoesModel)

        const usuario = await this.obtemUsuarioLogado()
        await new FirebaseWrapper().configuraTopicsFirebaseAdmin(usuario.admin)
    }

    async obtemUsuarioLogado(): Promise<UsuarioModel> {
        return await AppSession.getUser()
    }

    handlerPushNotification() {
        PushNotifications.addListener("pushNotificationActionPerformed", (pushNotificationActionPerformed: ActionPerformed) => {
            if (pushNotificationActionPerformed.actionId == "tap" 
                && pushNotificationActionPerformed.notification.data.command) {
                    let jsonParse = JSON.parse(pushNotificationActionPerformed.notification.data.command)
                    // se o usuário estiver tocado na notificação já redireciona, senão, salva no banco para redirecionar quando chegar na home
                    AppStorage.set(AppSession.CHAVE_COMMAND_PUSH, jsonParse)
                    new GatewayNotification(this.getContext()).builder(new CommandNotificationModel(jsonParse))
            }
        })
    }

    async salvaTokenApi(fcmToken: string) {
        await this.tokenProvider.salvaTokenApi(fcmToken)
    }

    async obtemOpcoesNotificacao() {
        let retorno = await this.notificacoesModel.obtemOpcoesNotificacoes()
        try {
            retorno = new TratamentoGatewayService(this.getContext()).builder(retorno)
            if (retorno.status == ResponseModel.STATUS_OK) {
                this.getContext().setOpcoesNotificacoes(await FirebaseWrapper.trataRetornoPreferenciasNotificacao(retorno.data))
            }else if (retorno.status == ResponseModel.STATUS_NOT_FOUND) {
                // Se não existir uma lista, cadastra uma lista default com todos marcados true
                await this.notificacoesModel.enviaOpcoesNotificacoes(this.notificacoesModel);
                this.configuraTopicsFirebase(this.notificacoesModel);
            }
             else {
                throw new Error(ThrowError.MESSAGE_DEFAULT)
            }
        } catch (e) {}
    }
}